import RouterPathProvider from "@core/RouterPath/RouterPathProvider";
import type GitStorageData from "@ext/git/core/model/GitStorageData";
import type SourceData from "@ext/storage/logic/SourceDataProvider/model/SourceData";
import getStorageNameByData from "@ext/storage/logic/utils/getStorageNameByData";

const getClonePathname = (data: Pick<GitStorageData, "group" | "name"> & { source: SourceData }): string =>
	RouterPathProvider.getPathname({
		filePath: [],
		sourceName: getStorageNameByData(data.source),
		group: data.group,
		repo: data.name,
		catalogName: data.name,
		itemLogicPath: [],
		repNameItemLogicPath: [],
	}).toString();

export default getClonePathname;
